module.exports = __webpack_public_path__ + "media/assets/services_manager/paycheck-a9c9b0aae5bcd121534772654537617064c27be0ccd5c1795cb8340815e8b9ae.png";